import { createDetailReducer } from '../../../common/services/reducerCreator';

export default createDetailReducer({
  modelName: 'CLUBSPONSOR',
  inside: {
    club: { get: 'clubSponsors', set: 'clubSponsor' },
  },
});
